export default "<p>\r\n  entregas-completas works!\r\n</p>\r\n"